import {
  IconWrapper,
  IStyles,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, Button, Modal, Slide, SxProps } from '@mui/material';
import { ReactElement } from 'react';

interface IProps {
  open: boolean;
  handleClose: () => void;
  popupBody: ReactElement<any, any>;
  mainContainerSx?: SxProps;
  rootSx?: SxProps;
}
export const ChapterTopicPopup = ({
  open,
  handleClose,
  popupBody,
  mainContainerSx,
  rootSx,
}: IProps) => {
  const styles: IStyles = {
    modal: {
      boxSizing: 'border-box',
      display: { xs: 'flex', md: 'flex' },
      alignItems: { xs: 'flex-end', md: 'center' },
    },
    root: {
      width: { xs: '90%', md: pxTovW(800), lg: pxTovW(600) },
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: { xs: pxToRem(10), md: pxTovW(20) },
      justifyContent: 'center',
      alignItems: { xs: 'center', md: 'flex-start' },
      margin: 'auto',
      border: 'none',
      outline: 'none',
      ...rootSx,
    },
    mainContainer: {
      boxSizing: 'border-box',
      backgroundColor: 'common.white',
      width: { xs: '95%', md: pxTovW(700), lg: pxTovW(537) },
      // height: { xs: 'max-content', md: pxTovW(845), lg: pxTovW(750) },
      maxHeight: { xs: '80vh', md: pxTovW(845), lg: pxTovW(750) },
      margin: 'auto',
      p: { xs: pxToRem(10), md: pxTovW(15) },
      borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
      border: 'none',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      ...mainContainerSx,
    },
  };

  return (
    <Modal open={open} onClose={() => handleClose()} sx={styles.modal}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box sx={styles.root}>
          <Box sx={styles.mainContainer}>{popupBody}</Box>
          <Box>
            <Button onClick={handleClose} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33) },
                  height: { xs: pxToRem(33) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
